import { TFunction } from 'i18next'
import { OnboardingStep } from './tour.types'

type Chapter = 'orient' | 'govern' | 'execute' | 'align' | 'close'

const step = (
  id: string,
  route: string,
  target: string,
  placement: OnboardingStep['placement'],
  chapter: Chapter,
  t: TFunction
): OnboardingStep => ({
  id,
  route,
  target,
  placement,
  isFixed: true,
  spotlightPadding: placement === 'right' ? 8 : 10,
  offset: 14,
  skipBeacon: true,
  disableFocusTrap: true,
  title: t(`onboarding.steps.${id}.title`),
  content: t(`onboarding.steps.${id}.description`),
  data: {
    chapter: t(`onboarding.chapters.${chapter}`),
    hint: t(`onboarding.steps.${id}.hint`),
  },
})

export const buildOnboardingSteps = (t: TFunction): OnboardingStep[] => [
  step(
    'commandCenter',
    '/',
    '[data-tour-id="dashboard-tabs"]',
    'bottom',
    'orient',
    t
  ),
  step(
    'sidebar',
    '/',
    '[data-tour-id="sidebar-navigation"]',
    'right',
    'orient',
    t
  ),
  step(
    'maturityNav',
    '/',
    '[data-tour-id="nav-maturity"]',
    'right',
    'govern',
    t
  ),
  step(
    'maturityPage',
    '/maturite',
    '[data-tour-id="maturity-page-header"]',
    'bottom',
    'govern',
    t
  ),
  step(
    'maturityKpis',
    '/maturite',
    '[data-tour-id="maturity-kpis"]',
    'bottom',
    'govern',
    t
  ),
  step(
    'maturityFamilies',
    '/maturite',
    '[data-tour-id="maturity-families"]',
    'top',
    'govern',
    t
  ),
  step(
    'maturityAnalysis',
    '/maturite',
    '[data-tour-id="maturity-view-analysis"]',
    'left',
    'govern',
    t
  ),
  step(
    'missionsPage',
    '/missions',
    '[data-tour-id="missions-page-header"]',
    'bottom',
    'execute',
    t
  ),
  step(
    'frameworksNav',
    '/missions',
    '[data-tour-id="nav-frameworks"]',
    'right',
    'align',
    t
  ),
  step(
    'mappingPage',
    '/securityFramework',
    '[data-tour-id="frameworks-page-header"]',
    'bottom',
    'align',
    t
  ),
  step(
    'mappingStepper',
    '/securityFramework',
    '[data-tour-id="mapping-stepper"]',
    'bottom',
    'align',
    t
  ),
  step(
    'mappingCatalog',
    '/securityFramework',
    '[data-tour-id="mapping-catalog"]',
    'top',
    'align',
    t
  ),
  step(
    'workspace',
    '/',
    '[data-tour-id="topbar-workspace"]',
    'bottom-end',
    'close',
    t
  ),
]
